module.exports = __webpack_public_path__ + "img/analyse.a15d7145.png";